// @flow
import * as React from 'react';
import { Box } from 'gestalt';

type Props = {|
  display?: 'block' | 'inlineBlock',
  children: React.Node,
  id: string,
|};

export default function Testable(props: Props) {
  const { children, display, id } = props;

  return (
    <Box data-test-id={id} display={display}>
      {children}
    </Box>
  );
}
